exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-0fd33158]::-webkit-inner-spin-button,input[data-v-0fd33158]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-0fd33158]{-moz-appearance:textfield}.div-control[data-v-0fd33158]{display:block;width:100%;padding:.2em .75rem;font-size:14px;font-weight:400;line-height:1.1;font-style:italic;color:#495057;background-color:#e9ecef;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;box-shadow:inset 0 0 0 transparent;transition:border-color .15s ease-in-out,box-shadow .15s}", ""]);

// exports
